import { isDevelopment, userTypePhysician } from './URL';
import store from '../sessionStorage';
import { encode } from 'base-64';
import moment from 'moment';
import 'moment-timezone';

export function myLog(...messgae) {
    if (isDevelopment) {
        console.log(messgae);
    }
}

export function encryptBase64(data) {
    return encode(data);
}

export const ValidURL = (str) => {
    let regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\\/]))?/;
    return !regex.test(str) ? false : true;
};

export const getBaseName = () => {
    let type = store.get('userSession') && store.get('userSession').userDetails.userType;
    if (type === userTypePhysician) {
        return 'doctor';
    }
};

export const fileToBase64 = (file, callback) => {
    let reader = new FileReader();
    if (file) {
        reader.readAsDataURL(file);
    }
    reader.onload = () => {
        callback(reader.result, true);
    };

    reader.onerror = () => {
        callback(null, false);
    };
};

export const adminUserId = (callBack) => {
    let userId = 0;
    if (store.get('adminSession')) {
        userId = store.get('adminSession').id;
    }
    callBack(userId);
};

export const insAdminUserId = (callBack) => {
    let userId = 0;
    if (store.get('insAdminSession')) {
        userId = store.get('insAdminSession').id;
    }
    callBack(userId);
};

export const validateEmail = (email) => {
    let reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return reg.test(email) ? true : false;
};

// timezone (optional): IANA name, e.g. the user's profile timezone; defaults to the browser offset
export const getSystemDateFromUTC = (date, timezone) => {
    let utcDate;
    if (typeof date === 'number') {
        utcDate = moment.utc(date);
    } else {
        utcDate = moment.utc(
            date,
            ['ddd MMM DD HH:mm:ss [UTC] YYYY', 'YYYY-MM-DD HH:mm:ss.S'],
            true
        );
    }
    if (utcDate.isValid() && timezone && moment.tz.zone(timezone)) {
        return utcDate.tz(timezone).format('MMM D, YYYY, hh:mm A');
    }
    const localOffset = moment().utcOffset();
    const cdtDate = utcDate.isValid() ? utcDate.utcOffset(localOffset) : null;
    return cdtDate ? cdtDate.format('MMM D, YYYY, hh:mm A') : '';
};

export const currencyFormat = (number) => {
    if (number < 1000) {
        return number;
    } else if (number >= 1000 && number < 1_000_000) {
        return (number / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
    } else if (number >= 1_000_000 && number < 1_000_000_000) {
        return (number / 1_000_000).toFixed(2).replace(/\.0$/, '') + 'M';
    }
};

export const customStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: '#181B22',
        borderColor: '#34373E',
        color: '#B9B9B9',
        ':hover': {
            borderColor: '#34373E',
        },
    }),
    input: (provided) => ({
        ...provided,
        color: '#B9B9B9',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#B9B9B9',
    }),
    option: (provided, state) => {
        return {
            ...provided,
            backgroundColor: state.isFocused ? '#2a87d0' : 'none',
            color: 'white',
            ':hover': {
                backgroundColor: '#2a87d0',
                color: 'white',
            },
        };
    },
    singleValue: (provided) => ({
        ...provided,
        color: 'white',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#10DACE',
        border: 'none',
        ':hover': {
            color: '#10DACE',
        },
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#543cc2',
        borderRadius: '4px',
        fontSize: '16px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'white',
        padding: '2px 6px',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: '#28235C',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#181B22',
        zIndex: 1000,
        position: 'absolute',
    }),
    menuList: (provided) => ({
        ...provided,
        backgroundColor: '#181B22',
        padding: '0',
        color: 'white', // Ensure menu list text color is white
    }),
};

export const validateSearchInput = (input) => {
    // Regular expression to match allowed characters: letters, numbers, .-_+@
    const regex = /^[a-zA-Z0-9._\-+@\s]*$/;
    return regex.test(input);
};

export const validateSearchNameInput = (input) => {
    // Regular expression to match allowed characters: letters, numbers
    const regex = /^[a-zA-Z0-9\s]*$/;
    return regex.test(input);
};

export const formatMessage = (message, params = {}) => {
    if (typeof message !== 'string') return '';

    return message.replace(/{(\w+)}/g, (_, key) => {
        return params[key] !== undefined ? params[key] : `{${key}}`;
    });
};